export default __webpack_public_path__ + "static/media/ballBlue.d651be1b.svg";